import { defineMessages } from 'react-intl-next';

export default defineMessages({
    genericError: {
        defaultMessage: 'An error occurred when loading the attachments field',
        description: 'Default message when an error occurs loading the media picker',
        id: 'sd.request.create.attachment.field.error',
    },
});
